import { filtersHelper } from '@/utils';
import { candidateModel } from '@/models/api/candidate.model';

export const candidateLanguageModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    write: data.write,
    read: data.read,
    listen: data.listen,
    spoken: data.spoken,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    candidate: data.candidate ? candidateModel(data.candidate) : null,
});